module.exports = __webpack_public_path__ + "img/交通.cee880d1.gif";